import { EntityConfig } from '../hooks/useEntity';

export interface JournalEntry {
  id: string;
  userId: string;
  classId?: string; // Optional - for class-specific logs
  className?: string; // Optional - display name for the class
  category: 'Course' | 'Research' | 'Personal' | 'Work' | 'Other'; // Tag for filtering
  subject?: string; // NEW: Subject/log number (like email subject)
  title: string;
  entryDate: string;
  entryTime: string;
  moduleNumber?: string;
  dueDate?: string;
  content: string; // Rich text HTML content
  images?: string[];
  entryType: 'discussion' | 'journal' | 'log';
  createdAt: string;
  updatedAt: string;
}

export const journalEntryEntityConfig: EntityConfig<JournalEntry> = {
  entityType: 'JournalEntry',
  properties: {
    userId: { type: 'string', required: true },
    classId: { type: 'string', required: false },
    className: { type: 'string', required: false },
    category: { type: 'string', required: true },
    subject: { type: 'string', required: false },
    title: { type: 'string', required: true },
    entryDate: { type: 'string', required: true },
    entryTime: { type: 'string', required: true },
    moduleNumber: { type: 'string', required: false },
    dueDate: { type: 'string', required: false },
    content: { type: 'string', required: true },
    images: { type: 'json', required: false },
    entryType: { type: 'string', required: true },
    createdAt: { type: 'string', required: false },
    updatedAt: { type: 'string', required: false },
  },
  orderBy: { field: 'entryDate', direction: 'desc' },
};
